import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Les logs de cycle de vie Stimulus (#initialize, #connect, #disconnect)
// partaient en production et noyaient la console. Vite remplace
// `import.meta.env.DEV` à la compilation : en production la condition est
// figée à false et le mode debug disparaît du bundle.
application.debug = import.meta.env.DEV
window.Stimulus = application

export { application }
